import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('workflow_estrutural', '');

// Actions são ações que o resource terá.
// No exemplo abaixo, criamos uma ação 'list', que é um GET
// na url que aponta para a raíz da API
const workflowActions = {
  atualizar: { method: 'PUT', url: `${basePath}cadastro` },
  ativar: { method: 'PUT', url: `${basePath}cadastro/ativacao/{id}/true` },
  gravar: { method: 'POST', url: `${basePath}cadastro` },
  buscaUnica: { method: 'GET', url: `${basePath}cadastro/{id}` },
  busca: { method: 'GET', url: `${basePath}cadastro/fluxo/{id}` },
  inativar: { method: 'PUT', url: `${basePath}cadastro/ativacao/{id}/false` },
  buscarTipos: { method: 'GET', url: `${basePath}cadastro/tipos` },
  buscarCondicionais: { method: 'GET', url: `${basePath}cadastro/condicional/{id}` },
  listar: { method: 'GET', url: `${basePath}cadastro?tamanhoPagina={size}&numeroPagina={page}` },
  listarAtivos: { method: 'GET', url: `${basePath}?tamanhoPagina=40&numeroPagina=1&nome={nome}&indAtivo=true` },
  buscarDescricoes: { method: 'GET', url: `${basePath}cadastro/passo/descricao{/idTipo}` },
};

// Exportamos então o recurso, que não passa de uma função que recebe um
// Vue.$resource como parâmetro e retorna um resource customizado.
// Vue.$resource tem a seguinte assinatura:
// function Resource(url, params, actions, options)

export default resource => resource(`${basePath}`, {}, workflowActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/workflow-cadastro.js